<input
    type="text"
    class="form-control"
    name="datepicker"
    [ngClass]="{ 'input-group-sm': small_input, 'w-100': full_width, 'is-invalid': isInvalid }"
    [(ngModel)]="date"
    [appDatepicker]="date"
    (dateSelected)="onDateSelect($event)"
    [disabled]="isReadonly"
    placeholder="Click for date"
/>